export default "__VITE_ASSET__bdb1f41d__$_?react__"